import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Card,  CardContent, Grid, Typography, Avatar, Divider, IconButton} from '@material-ui/core';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import RefreshIcon from '@material-ui/icons/Refresh';
import { getISOMoeda } from 'lib/functions';

const useStyles = makeStyles(theme => ({
  root: {
    height: '100%',
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText
  },
  content: {
    alignItems: 'center',
    display: 'flex'
  },
  title: {
    fontWeight: 700
  },
  avatar: {
    backgroundColor: theme.palette.white,
    color: theme.palette.primary.main,
    height: 56,
    width: 56
  },
  icon: {
    height: 32,
    width: 32
  }
}));

const ProducaoVendedor = props => {
  const { className, ...rest } = props;

  const classes = useStyles();

  const refreshDados = ()=>{
    window.location.reload();
    //console.log('recarregou a página...');
    //ReactDOM.render(ProducaoServico, document.getElementById('root'))
  }


  const moeda = getISOMoeda(sessionStorage.getItem('moeda'));
  
  const totalProducaoComissao = rest.totalProducaoComissao.toLocaleString(moeda.abrevMoeda, { style: 'currency', currency: moeda.isoMoeda });
  const totalProducaoComissaoServicoExtra = rest.totalProducaoComissaoServicoExtra.toLocaleString(moeda.abrevMoeda, { style: 'currency', currency: moeda.isoMoeda });
  const totalProducaoComissaoServicoFat = rest.totalProducaoComissaoServicoFat.toLocaleString(moeda.abrevMoeda, { style: 'currency', currency: moeda.isoMoeda });
  
  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardContent>
        <Grid
          container
          justify="space-between"
        >
          <Grid item>
            <Typography
              className={classes.title}
              color="inherit"
              gutterBottom
              variant="body2"
              
            >
              PRODUÇÃO COMISSÃO VENDEDORES
            </Typography>
            <Typography
              color="inherit"
              variant="h2"
            > {totalProducaoComissao}

              <IconButton 
                alignItems= "right"                
                color="inherit" 
                size="small"
              >
                <RefreshIcon 
                  onClick={refreshDados}
                />
              </IconButton>

            </Typography>
            <br/>
            <Typography
              color="inherit"
              variant="h5"
              style={{display: (sessionStorage.getItem('mod-ger-tipoExtraFat') == 3) ? '' : 'none'}}
            >
             EXTRAS - {totalProducaoComissaoServicoExtra}
            </Typography>
            <Divider />          

            <Typography
              color="inherit"
              variant="h5"
              style={{display: (sessionStorage.getItem('mod-ger-tipoExtraFat') == 3) ? '' : 'none'}}              
            >
             FATURADOS - {totalProducaoComissaoServicoFat}             
            </Typography>
            

          </Grid>
          <Grid item>
            <br/>
            <Avatar className={classes.avatar}>
              <AttachMoneyIcon className={classes.icon} />
            </Avatar>
          </Grid>
        </Grid>
        <div>
        
        </div>
      </CardContent>
    </Card>
  );
};

ProducaoVendedor.propTypes = {
  className: PropTypes.string
};

export default ProducaoVendedor;
